<script lang="ts" module>
  import { generateId, reactiveContext } from "#lib/internal/helpers"

  const key = "dialogKey"

  type DialogRootContext = {
    open: boolean
    triggeredId: string | null
    overlay: boolean
    titleId: string
    descriptionId: string
    contentId: string
  }

  const { getContext, setContext } = reactiveContext<DialogRootContext>(
    {
      open: false,
      triggeredId: null,
      overlay: true,
      titleId: generateId(),
      descriptionId: generateId(),
      contentId: generateId(),
    },
    key
  )

  export const getDialogRootContext = getContext

  export type DialogRootProps = {
    open?: boolean
    overlay?: boolean
    children?: Snippet
  }
</script>

<script lang="ts">
  import type { Snippet } from "svelte"

  type Props = {
    open?: boolean
    overlay?: boolean
    children?: Snippet
  }

  let {
    open = $bindable(false),
    overlay = $bindable(true),
    children,
  }: Props = $props()

  const rootCtx = setContext({
    open: (v) => {
      if (v !== open) open = v
    },
    overlay: (v) => {
      if (v !== overlay) overlay = v
    },
  })

  $effect(() => {
    rootCtx.update((v) => ({ ...v, open, overlay }))
  })
</script>

{@render children?.()}
